<div class="ks-empty" role="status">
  <span class="ks-empty__icon" aria-hidden="true">
    <i class="bi bi-{{ icon() }}"></i>
  </span>

  <p class="ks-empty__title">{{ title() }}</p>
  <p class="ks-empty__message">{{ message() }}</p>

  <div class="ks-empty__actions">
    <ng-content />
  </div>
</div>
